import {COLORS, GenericIconName, Icon, Text} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';

export const BasketTotalCoinsRow: React.FC<{
  className?: string;
  title: string;
  amount: string;
}> = ({className, title, amount}) => {
  return (
    <Wrapper className={className}>
      <StartOfLineWrapper>
        <Icon asset={GenericIconName.Coins} size="SS" />
        <Text
          size="px14"
          weight="mediumBold"
          data-testid="basketTotalCoinsRowTitle"
        >
          {title}
        </Text>
      </StartOfLineWrapper>
      <Text
        size="px14"
        weight="mediumBold"
        color="NotificationsGreen100"
        data-testid="basketTotalCoinsRowValue"
      >
        {amount}
      </Text>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem;

  border-radius: 0.25rem;
  background-color: ${COLORS['Fill.Grey.Primary']};
`;

const StartOfLineWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.25rem;
  align-items: center;
`;
